import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { AutomotiveAftermarketProfileDetails, AutomotiveAftermarketProfileModel } from '../models';
import { AutomotiveAftermarketProfileEndpoint } from '../constants/automotive-aftermarket-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class AutomotiveAftermarketProfileItemBriefService {
  constructor(private http: WrapperHttpService) {}

  saveAutomotiveAftermarketProfile(
    body: Partial<AutomotiveAftermarketProfileDetails>,
  ): Observable<AutomotiveAftermarketProfileDetails> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}`;
    return this.http.withLoading().patch<AutomotiveAftermarketProfileModel>(url, body);
  }

  cloneAutomotiveAftermarketProfile(
    body: Partial<AutomotiveAftermarketProfileDetails>,
  ): Observable<AutomotiveAftermarketProfileDetails> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}${AutomotiveAftermarketProfileEndpoint.Clone}`;
    return this.http.withLoading().post<AutomotiveAftermarketProfileDetails>(url, body);
  }

  deleteAutomotiveAftermarketProfile(profileId: number): Observable<AutomotiveAftermarketProfileModel> {
    const url = `${API_URL}${AutomotiveAftermarketProfileEndpoint.Base}${AutomotiveAftermarketProfileEndpoint.Profiles}/${profileId}`;
    return this.http.withLoading().delete<AutomotiveAftermarketProfileModel>(url);
  }
}
